import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const createLab = async (parentId, labData, type = 'section') => {
    const response = await axiosAgent.post(
        `${ApiConfig.labs.create}/${parentId}?type=${type}`,
        labData
    );
    return response.data;
};

export const editLabApi = async (labId, labData) => {
    const response = await axiosAgent.put(
        `${ApiConfig.labs.edit}/${labId}`,
        labData
    );
    return response.data;
};

export const deleteLab = async (labId, parentId, type = 'section') => {
    const response = await axiosAgent.delete(
        `${ApiConfig.labs.delete}/${labId}/${parentId}?type=${type}`
    );
    return response.data;
};

export const getIndividualLab = async (labId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.labs.getIndividual}/${labId}`
    );
    return response.data;
};
